import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MuscleBackendManager from "@lib/data/templates/backend-manager.class";
class AutocompleteManager extends MuscleBackendManager {
  constructor() {
    var _process$env$NEXT_PUB;
    super((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_MUSCLE_CUSTOMERS_API) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "http://localhost:3002/api/v1");
    this.getCarsAutocompleteResults = async term => {
      try {
        var _rawResult$data;
        const params = "term=".concat(term, "&hotel_search=false&cars_search=true&flights_search=false");
        const rawResult = await super.getAxiosInstance().get("/autocomplete/locations?".concat(params));
        if ((_rawResult$data = rawResult.data) !== null && _rawResult$data !== void 0 && _rawResult$data.code) {
          return rawResult.data;
        }
        const res = rawResult.data.locations;
        return res.map(item => _objectSpread(_objectSpread({}, item), {}, {
          type: "CARS"
        }));
      } catch (error) {
        if (error.code) {
          throw new Error(error);
        } else {
          throw new Error("Unknown error: ".concat(error));
        }
      }
    };
    this.getHotelsAutocompleteResults = async term => {
      try {
        var _rawResponse$data;
        const params = "term=".concat(term, "&hotel_search=true&cars_search=false&flights_search=false");
        const rawResponse = await super.getAxiosInstance().get("/autocomplete/locations?".concat(params));
        if ((_rawResponse$data = rawResponse.data) !== null && _rawResponse$data !== void 0 && _rawResponse$data.code) {
          return rawResponse.data;
        }
        const res = rawResponse.data.filter(item => item.value !== null);
        return res;
      } catch (error) {
        if (error.code) {
          throw new Error(error);
        } else {
          throw new Error("Unknown error: ".concat(error));
        }
      }
    };
  }
}
export default new AutocompleteManager();